import { LabelingObjectData, BoxObject, EllipseObject, PolygonObject } from '@/stores/slices/Labeling/types'
import { ANNOTATION_TYPE } from '@/pages/Labeling/types'

export const isBox = (data?: LabelingObjectData): data is BoxObject => data?.t === ANNOTATION_TYPE.BOX

export const isEllipse = (data?: LabelingObjectData): data is EllipseObject => data?.t === ANNOTATION_TYPE.ELLIPSE

export const isPolygon = (data?: LabelingObjectData): data is PolygonObject & { isPathEditable: true } => data?.t === ANNOTATION_TYPE.POLYGON && data.isPathEditable

export const isBrush = (data?: LabelingObjectData): data is PolygonObject & { isPathEditable: false } => data?.t === ANNOTATION_TYPE.POLYGON && !data.isPathEditable
